/**
 * this file contains all redux-saga watchers & workers for the transaction
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'
import moment from 'moment'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'

// import action creators
import * as TransactionActions from '../actions/transactionActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF TRANSACTIONS
----------------------------------------------------------------------------- */

// watcher saga for fetching the transaction data
export function* watchFetchTransaction() {
    yield takeEvery(C.FETCH_TRANSACTION_DATA, workerFetchTransaction)
}

// worker saga for fetching the transaction data
function* workerFetchTransaction() {

    // get the store content
    //const state = yield select();

    // get the token from store
    //const token = state.<someState>.<user>.<something>.<token>

    // set the headers
    const headers = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            //"Authorization": token
        },
        mode: 'cors', // NOTE: make sure Mulesoft endpoint allows CORS !!!!!!
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.transactionFetchURL

    // http://smsf-proxy.cloudhub.io/class/fund/DEMO_SMSF/fetch/
    // transaction_amount/2018-05-05/2018-05-10?client_id=84c2c79aa9194a2ea1581a5adf4f3b4c&client_secret=C48231B007524550a571c1b0Ee2A0Da2

    // const requestURL = endpoints.baseUrlDev + 'transaction_amount/' +
    //     state.dashboardState.tStartDate + '/' +
    //     state.dashboardState.tEndDate +
    //     '?client_id=' + state.<someState>.<user>.<something>.<id> +
    //     '&client_secret=' + state.<someState>.<user>.<something>.<token>

    try {

        // show the loader
        yield put(TransactionActions.showTransactionLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        /*
         * ---------------- RESPONSE DATA STRUCTURE ----------------
            {
                "data": {
                    "Data": {
                        "FundCode": "DEMO_SMSF",
                        "FundName": "Demo Superannuation Fund",
                        "Period": {
                            "StartPeriodDate": "2018-05-05",
                            "EndPeriodDate": "2018-05-10",
                            "IsEmpty": false,
                            "IsPopulated": true,
                            "NumberOfDaysContained": 6
                        },
                        "MovementDescriptions": [
                            {
                                "PortfolioName": "Default",
                                "BankAccountDetails": [
                                    {
                                        "OpeningBalance": 77794.4,
                                        "ClosingBalance": 77794.4,
                                        "OpeningBalanceDate": "2018-05-05",
                                        "CurrencyCode": "AUD",
                                        "AccountBSB": "182-512",
                                        "AccountNumber": "12122017",
                                        "AccountCode": "MBL.BACCT",
                                        "AccountDescription": "Macquarie CMA",
                                        "Status": "Active",
                                        "Transactions": [
                                            {
                                                "Date": "2018-05-29T13:50:16.2792852+10:00",
                                                "Amount": 2,
                                                "Direction": "Acquisition",
                                                "Description": "sample string 3",
                                                "index": 4,
                                                "DepositAmount": 5,
                                                "WithdrawalAmount": 6,
                                                "RunningTotal": 7
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "Errors": []
                }
            }
        */

        if(!isEmpty(response.data)) {


            // get the array of transaction objects
            // TODO: that needs to be changed
            // https://butterflygroup.atlassian.net/secure/RapidBoard.jspa?rapidView=82&view=planning&selectedIssue=WIL-604
            const bankAccountDetails = response.data.Data.MovementDescriptions[0].BankAccountDetails[0]

            //console.log(JSON.stringify(bankAccountDetails, null, 4))

            // set the closing balance
            yield put(TransactionActions.setTransactionClosingBalance(
                parseFloat(bankAccountDetails.ClosingBalance, 10)
            ))

            // set the transaction list
            yield put(TransactionActions.setTransactionData(
             bankAccountDetails.Transactions
            ))

            // set the success flag to true
            yield put(TransactionActions.setTransactionFetchSuccess(true))
        }

    } catch (error) {

        // set the success flag to false
        yield put(TransactionActions.setTransactionFetchSuccess(false))

    } finally {

        // hide the loader regardless
        yield put(TransactionActions.showTransactionLoader(false))
    }
}

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO RESET THE DATE RANGE
----------------------------------------------------------------------------- */

// watcher saga for resetting the date range
export function* watchClearDateRange() {
    yield takeEvery(C.CLEAR_DATE_RANGE, workerClearDateRange)
}

// worker saga for resetting the date range
function* workerClearDateRange() {

    // set the start date of NOW
    yield put(TransactionActions.setTransactionStartDate(
        moment()
    ))

    // set the start date of NOW + 6 months
    yield put(TransactionActions.setTransactionEndDate(
        moment().add(6, 'months')
    ))
}



// WEBPACK FOOTER //
// ./src/sagas/transactionSaga.js